

import { useContext, useEffect, useRef, useState } from 'react'
import Paginator from '../../components/ui/Paginator';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { UsersContext } from '../../context/users/UserContext';
import { useNavigate } from 'react-router-dom';
import { User } from '../../models/interfaces';
import Message from '../../components/ui/Message';
import { AuthContext } from '../../context/auth';
import { GroupsDefault } from '../../utils/Constants';


 

export const UsersPage = () => {
    const [buscar, setBuscar] = useState('');
    const [pageActual, setPageActual] = useState<number>(1);
    const {  users, totalPage, loadUsers, deleteUser, isLoading } = useContext(UsersContext);
    const navigate = useNavigate();
    const [details, setDetails] = useState('');
    const { user } = useContext( AuthContext );   
    const [showBank, setShowBank]= useState(false);
    const [showComercio, setShowComercio]= useState(false);
    const [actualGroup, setActualGroup]= useState('');

    const initialPageActual = useRef(pageActual);
    const initialActualGroup = useRef(actualGroup);
    
    useEffect(() => {
        //setShowBank(user.banks.length == 0)
    }, [])

    
    useEffect(() => {
        const isBackoffice = user.banks.length == 0;
        setActualGroup(isBackoffice ? GroupsDefault.GROUP_BACKOFFICE : GroupsDefault.GROUP_PORTAL)       
    }, [])

    useEffect(() => {
        
        if (initialPageActual.current !== pageActual || initialActualGroup.current !== actualGroup) {
          
           loadUsers(pageActual - 1, actualGroup);
        }
    
        // Actualiza el estado inicial después de la carga inicial
        initialPageActual.current = pageActual;
        initialActualGroup.current = actualGroup;
    
        // Este efecto solo se ejecutará en cambios posteriores a la carga inicial
      }, [pageActual, actualGroup]);

   
    const filteredData = users.filter((user) =>
        user.user_name.toString().toLowerCase().includes(buscar.toLowerCase())
    );

    const handleNew = ()=>{
        navigate("/user");
    }   

    const handleEdit = (user:User)=>{
        navigate("/user", { state: { user } });
    }

    const handleDelete = async (user_id) => {
        
        const resp = await deleteUser(user_id);
        if(resp !== "success"){
            alert(resp);
        }
    }

    const handleGroups = (user:User) => {
            navigate('/user/group', { state: { user } });
        };

    const handleDetails = (user:User)=>{
        var message = "UserId: " + user.user_id  + "\nUserToken: " + user.user_token + "\nMerchantId: " 
        + user.merchants[0].merchant_code;
        if(user.merchants[0].merchant_code_dol != null){
            message += "\nMerchantId (USD): " + user.merchants[0].merchant_code_dol
        } 
        setDetails(message);
    }

    const hideDetails = async (copy)=>{
        if(copy){
            //navigator.clipboard.writeText(details)            

            try {
                if (navigator.clipboard && window.isSecureContext) {
                  await navigator.clipboard.writeText(details);
                } else {
                  const textArea = document.createElement('textarea');
                  textArea.value = details;
          
                  textArea.style.position = 'absolute';
                  textArea.style.left = '-999999px';
          
                  document.body.prepend(textArea);
                  textArea.select();
          
                  document.execCommand('copy');
                  textArea.remove();
                }
          
              } catch (error) {
                console.error('Error copying to clipboard:', error);
              }
        }
        setDetails('');
    }

    const filterUser = (group)=>{
        setPageActual(1);
        setActualGroup(group);

        if(group == GroupsDefault.GROUP_BACKOFFICE){
            setShowComercio(false);
        }
        else{
            setShowComercio(true);
        }
    }

    const getClassName = (groupOption)=>{
        return actualGroup == groupOption ? "btn btn-outline-primary active": "btn btn-outline-primary";
    }

    


    return (
        
        <div className='mt-5 container' style={ styles.container }>

            

            <div className="row justify-content-end mt-5">
                <div className=' col-md-4' style={{textAlign: 'right'}}>
                    
                    {/* <div className="btn-group" role="group" aria-label="Basic outlined example">                        
                        {showBank ? <button type="button" className={ getClassName(GroupsDefault.GROUP_BACKOFFICE)} onClick={()=>filterUser(GroupsDefault.GROUP_BACKOFFICE)}>Banco</button> : ''}
                        <button type="button" className={ getClassName(GroupsDefault.GROUP_PORTAL)} onClick={()=>filterUser(GroupsDefault.GROUP_PORTAL)}>Portal</button>
                        <button type="button" className={ getClassName(GroupsDefault.GROUP_TOP)} onClick={()=>filterUser(GroupsDefault.GROUP_TOP)}>Tap on phone</button>
                    </div> */}
                </div>
                <div className=' col-md-3' style={{position: 'revert'}}>
                    <input className="form-control" id="search" type="text" placeholder="Buscar" value={buscar}  onChange={(e) => setBuscar(e.target.value)}/> 
                </div>
                <div className=' col-md-1' style={{position: 'revert'}}>
                    <button type="button" className="btn btn-success" onClick={handleNew}>Nuevo</button>
                </div>
            </div>
            <br></br>
            <div >

           
                <table className="table table-hover table-striped">
                    <thead className="thead-dark">
                        <tr>
                            <th>Usuario</th>
                            <th>Nombre</th>
                            <th>Email</th>
                            
                            {/* <th className={`${ showComercio  ? '' : 'visually-hidden'}`}>Comercio</th> */}
                            {/* <th className={`${ showBank  ? '' : 'visually-hidden'}`}>Banco</th> */}
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody >
                    {
                        filteredData.length > 0 
                        ?
                        filteredData.map(user => (
                            <tr key={user.user_id}>
                                <td style={styles.table_tbody_td}>{user.user_name} </td>
                                <td style={styles.table_tbody_td}>{user.name + ' ' + user.lastname}</td>
                                <td style={styles.table_tbody_td}>{user.email}</td>
                                
                                
                                {/* <td className={`${ showBank  ? '' : 'visually-hidden'}`} style={styles.table_tbody_td}>{user.banks[0].name}</td> */}
                                {/* <td style={{...styles.table_tbody_td, textAlign: 'center'}} >
                                    { 
                                    user.user_token != null && user.user_token != ''
                                    ?  <button 
                                        type="button" 
                                        className="btn btn-secondary" 
                                        onClick={()=>handleDetails(user)}> <i className="bi bi-info-circle"></i></button>
                                    : ''    
                                    }
                                    <button type="button" className="btn btn-primary" style={{marginLeft: '10px'}} onClick={()=>handleEdit(user)}> <i className="bi bi-pencil"></i></button>
                                    <button type="button" className="btn btn-danger" style={{marginLeft: '10px'}} onClick={()=>handleDelete(user.user_id)}><i className="bi bi-trash"></i></button>
                                </td>
                                 */}
                                 <td style={{ textAlign: 'center' }}>
                                    <div className="dropdown">
                                        <button
                                            className="btn btn-secondary dropdown-toggle"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <span className='bi bi-list'></span>
                                        </button>

                                        <ul className="dropdown-menu">
                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    onClick={() => handleEdit(user)}
                                                >
                                                    <i className="bi bi-pencil me-2"></i>
                                                    Editar
                                                </button>
                                            </li>

                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    onClick={() => handleGroups(user)}
                                                >
                                                    <i className="bi bi-people me-2"></i>
                                                    Grupos
                                                </button>
                                            </li>

                                            

                                            <li>
                                                <hr className="dropdown-divider" />
                                            </li>

                                            <li>
                                                <button
                                                    className="dropdown-item text-danger"
                                                    onClick={() => handleDelete(user.user_id)}
                                                >
                                                    <i className="bi bi-trash me-2"></i>
                                                    Eliminar
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        ))
                        :
                        <tr> <td colSpan={showBank  ? 8 : 7} className='text-center'>{ isLoading ? "Cargando..." : "No existen usuarios."}</td></tr>
                    }
                    
                    
                    </tbody>
                </table>  
            </div>  
            
            {
                totalPage > 1 ?  <Paginator totalPage={totalPage} pageActual={pageActual} onChange={(actual)=> setPageActual(actual)} />   : <div />
            }
            {
                
                    details.length > 0 ? <Message type='success' title='Datos usuario' okText='Copiar' message={details} closeDialog={()=>hideDetails(false)} handleOk={()=>hideDetails(true)} backgroundColor='rgba(0,0,0,0.4)'/> : ''
                  
            }
        </div>
    )
}


const styles = {
    container: {
        flex:1,
        marginTop: 10,
        marginHorizontal: 20
    },
    table_responsive: {
        
    },    
    table_tbody_td: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: '10px',
        paddingRight: '10px'
    }
};
